/**
 * PH Warenkorb – Rabattcode direkt im Drawer anwenden / entfernen.
 *
 * Nutzt die Cart AJAX API (/cart/update.js mit "discount") und rendert den
 * Drawer danach mit dem Theme-eigenen renderContents() neu. Der Code hängt
 * am Warenkorb und wird an der Kasse automatisch übernommen.
 */
(function () {
  if (window.__phCartDiscountReady) return;
  window.__phCartDiscountReady = true;

  let busy = false;

  function appliedCodes() {
    return Array.from(document.querySelectorAll('[data-ph-cart-discount] [data-ph-discount-code]'))
      .map((el) => el.dataset.phDiscountCode)
      .filter(Boolean);
  }

  function sameCode(a, b) {
    return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
  }

  async function updateCodes(codes) {
    const drawer = document.querySelector('cart-drawer');
    const body = { discount: codes.join(',') };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Cart update failed');
    }
    return { data, drawer };
  }

  function renderDrawer({ data, drawer }) {
    if (drawer && data.sections) drawer.renderContents(data);
  }

  function setMessage(text, type) {
    const el = document.querySelector('[data-ph-discount-message]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('hidden', !text);
    el.classList.toggle('is-error', type === 'error');
    el.classList.toggle('is-success', type === 'success');
  }

  function setBusy(state) {
    busy = state;
    const button = document.querySelector('[data-ph-discount-apply]');
    if (button) {
      button.disabled = state;
      button.classList.toggle('is-loading', state);
    }
  }

  async function applyCode(code) {
    const existing = appliedCodes();
    if (existing.some((c) => sameCode(c, code))) {
      setMessage(`„${code}“ ist bereits aktiv.`);
      return;
    }

    setBusy(true);
    setMessage('');

    try {
      let result = await updateCodes([...existing, code]);
      const codes = result.data.discount_codes;
      const entry = Array.isArray(codes) ? codes.find((d) => sameCode(d.code, code)) : { code, applicable: true };

      if (!entry || entry.applicable === false) {
        // Ungültigen Code sofort wieder entfernen, damit er nicht im Warenkorb/Checkout hängen bleibt
        result = await updateCodes(existing);
        renderDrawer(result);
        setMessage(`„${code}“ ist ungültig oder gilt nicht für diesen Warenkorb.`, 'error');
        return;
      }

      renderDrawer(result);
      setMessage(`Rabattcode „${entry.code || code}“ wurde angewendet.`, 'success');
    } catch (error) {
      console.error('[ph-cart-discount]', error);
      setMessage('Der Code konnte gerade nicht geprüft werden. Bitte versuche es erneut.', 'error');
    } finally {
      setBusy(false);
    }
  }

  async function removeCode(code) {
    if (busy) return;
    setBusy(true);
    try {
      const result = await updateCodes(appliedCodes().filter((c) => !sameCode(c, code)));
      renderDrawer(result);
      setMessage('');
    } catch (error) {
      console.error('[ph-cart-discount]', error);
      setMessage('Der Code konnte gerade nicht entfernt werden. Bitte versuche es erneut.', 'error');
    } finally {
      setBusy(false);
    }
  }

  // Delegiert: der Drawer wird nach jeder Änderung neu gerendert
  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-ph-discount-form]');
    if (!form) return;
    event.preventDefault();
    if (busy) return;
    const input = form.querySelector('[data-ph-discount-input]');
    const code = (input?.value || '').trim();
    if (code) applyCode(code);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-ph-discount-remove]');
    if (!button) return;
    event.preventDefault();
    removeCode(button.dataset.phDiscountRemove);
  });
})();
